import './EventProductsOutsideDates.scss';

import { ShoppingCartItem } from '../index';
import { formatPrice, getNumberOfGuests } from '@fshr/shared';
import { formatDateRange } from '@micro-apps/shared';
import Icon from '../../Icon';
import CTA from '../../Cta';
import { useTranslation } from '../../../hooks';

export default function EventProductsOutsideDates({
	eventProductsOutsideDates = [],
	formattedStayDateRange,
	removeItem,
	handleShowInfoModal,
}) {
	const { t } = useTranslation();

	return (
		<div className="EventProductsOutsideDates">
			<div className="EventProductsOutsideDates__message">
				<div className="EventProductsOutsideDates__message__top">
					<Icon icon="alert" className="EventProductsOutsideDates__message__top__icon" />
					<span
						className="EventProductsOutsideDates__message__top__text ty-c4"
						data-cy="EventProductsOutsideDates__message__top__text"
					>
						{t('Outstanding Itinerary Items')}
					</span>
				</div>
				<div className="EventProductsOutsideDates__message__main-text">
					{t(
						`The following items are outside your ${formattedStayDateRange} stay dates. You must remove them in order to checkout.`
					)}
				</div>
			</div>
			<div className="EventProductsOutsideDates__events">
				{eventProductsOutsideDates.map(
					({
						date,
						productId,
						name,
						productTotal,
						onRequestEventProductType,
						price,
						numAdults,
						numChildren,
						images,
					}) => {
						return (
							<div className="EventProductsOutsideDates__events__item" key={productId}>
								<span className="EventProductsOutsideDates__events__item__date">
									{formatDateRange(date)}
								</span>
								<ShoppingCartItem
									name={name}
									duration={price?.priceName}
									numberOfPeople={getNumberOfGuests({
										t,
										numberOfAdults: numAdults,
										numberOfChildren: numChildren,
									})}
									price={productTotal?.totalPrice?.amount}
									currencyCode={productTotal?.totalPrice?.currencyCode}
									insideCart={true}
									image={images?.[0]?.url}
									onRequestEventProductType={onRequestEventProductType}
									unitType={price?.priceDetail}
									showInfoModal={() => {
										const hotelProduct = {
											productId,
											name,
											productTotal,
											price,
											numAdults,
											numChildren,
										};
										handleShowInfoModal(
											hotelProduct,
											formatPrice(
												productTotal.totalPrice.amount,
												productTotal.totalPrice.currencyCode
											)
										);
									}}
								/>
								<CTA
									type="secondary"
									theme="light"
									className="EventProductsOutsideDates__events__item__cta"
									onClick={() =>
										removeItem({
											productId,
										})
									}
									dataCy="removeEventProductOutsideStayCTA"
								>
									{t('Remove')}
								</CTA>
							</div>
						);
					}
				)}
			</div>
		</div>
	);
}
